import React from 'react'
import { Link } from "react-router-dom";
import { useRecoilState } from 'recoil';
import { _programlandingdata } from '../RecoilState';


const FeaturedProgramCard = ({ cardinfo }) => {
    const [programlandingdata, setProgramlandingData] = useRecoilState(_programlandingdata)

    console.log(cardinfo)

    // never ever touch
    const bgcolor = cardinfo.bg_color_homepage
    const redirectURL = cardinfo.app_redirect_slug_homepage

    const transferState = () => {
        setProgramlandingData(cardinfo)
    }

    return (
        // <Link to=>
        <Link to={`/${redirectURL}`} onClick={() => transferState()}>
            <div className='m-2 pt-[25px] px-[15px] pb-[10px] rounded-lg min-h-[200px]' style={{ backgroundColor: bgcolor }}>
                <div className='flex justify-center'>
                    <img src={cardinfo.program_icon_homepage} width={85} alt={cardinfo.program_name_homepage} className='pb-[15px]' />
                </div>
                <p className='brand-font txt-bold text-[16px] leading-[18px]'>{cardinfo.program_name_homepage}</p>
            </div>
        </Link >
    )
}

export default FeaturedProgramCard